import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';
import type {
  TableSettingsBody,
  TableSettingsResponse
} from '@/app/common/api/types/tableSettingApiTypes';

const tableSettingApi = createApi({
  reducerPath: 'tableSettingApi',
  baseQuery: (...args) => customFetchBase(getBaseApiPath(), ...args),
  tagTypes: ['TABLE_SETTINGS'],
  endpoints: build => ({
    getTableSettingss: build.query<TableSettingsResponse, TableSettingsBody>({
      query: body => ({
        url: `go_handler/v2/table_settings/get`,
        method: 'POST',
        body
      }),
      providesTags: ['TABLE_SETTINGS']
    }),
    updateTableSettings: build.mutation<
      TableSettingsResponse,
      TableSettingsBody
    >({
      query: body => ({
        url: `go_handler/v2/table_settings/insert_or_update`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['TABLE_SETTINGS']
    })
  })
});

export const { useGetTableSettingssQuery, useUpdateTableSettingsMutation } =
  tableSettingApi;

export default tableSettingApi;
